import React from "react";
import styled from "styled-components";

interface SpaceBetweenProps {
  children: React.ReactChild | JSX.Element | JSX.Element[];
  [key: string]: any;
}

export default function SpaceBetween({ children, ...rest }: SpaceBetweenProps) {
  return <SpaceBetweenContainer {...rest}>{children}</SpaceBetweenContainer>;
}

const SpaceBetweenContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
